import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import Button from '@pattern-library/buttons';
import { ChevronDownBoldIcon, ChevronUpBoldIcon, InfoCircleIcon, SuccessCircleIcon, WarningIcon } from '@pattern-library/icon';
import { FocusService } from '@pattern-library/utils';
const ExpandableContent = _ref => {
  let {
    id,
    className,
    clickHandler = () => {},
    children,
    hideButton = 'Hide',
    iconType,
    lockOpen,
    qaId,
    showButton = 'Show',
    text,
    title,
    useContentBeforeButton = false
  } = _ref;
  const [isOpen, setIsOpen] = useState(false);
  const [focusableElements, setFocusableElements] = useState([]);
  const expandableContentTextRef = useRef(null);
  useEffect(() => {
    if (expandableContentTextRef.current) {
      setFocusableElements(FocusService.getFocusableElementsIn(expandableContentTextRef.current));
    }
  }, []);
  useEffect(() => {
    if (focusableElements.length > 0) {
      focusableElements.forEach(element => {
        element.tabIndex = isOpen ? 0 : -1;
      });
    }
  }, [isOpen, focusableElements]);
  const getIconElement = () => {
    const iconByType = {
      caution: /*#__PURE__*/React.createElement(WarningIcon, {
        size: "sm",
        color: "warning",
        label: "Caution"
      }),
      info: /*#__PURE__*/React.createElement(InfoCircleIcon, {
        size: "sm",
        color: "default",
        label: "Info"
      }),
      success: /*#__PURE__*/React.createElement(SuccessCircleIcon, {
        size: "sm",
        color: "success",
        label: "Success"
      }),
      warning: /*#__PURE__*/React.createElement(WarningIcon, {
        size: "sm",
        color: "error",
        label: "Warning"
      })
    };
    return iconByType[iconType || ''] || null;
  };
  const showClickHandler = () => {
    setIsOpen(!isOpen);
    clickHandler();
  };
  const isExpandable = Boolean(text) || Boolean(children);
  const containerClassNames = classNames('asc-expandable-content-container', {
    'asc-expandable-content-open': lockOpen || isOpen,
    [className || '']: className,
    'asc-expandable-content-with-title': title
  });
  const textId = 'asc-expandable-content-text-' + id;
  const showButtonWithIcon = /*#__PURE__*/React.createElement(React.Fragment, null, showButton, /*#__PURE__*/React.createElement(ChevronDownBoldIcon, {
    color: "current",
    size: "xxs"
  }));
  const hideButtonWithIcon = /*#__PURE__*/React.createElement(React.Fragment, null, hideButton, /*#__PURE__*/React.createElement(ChevronUpBoldIcon, {
    color: "current",
    size: "xxs"
  }));
  const expandableContent = /*#__PURE__*/React.createElement("div", {
    className: "asc-expandable-content-text",
    "aria-hidden": !isOpen,
    id: textId,
    ref: expandableContentTextRef
  }, text, children);
  return /*#__PURE__*/React.createElement("div", {
    className: containerClassNames,
    "data-qa": qaId
  }, isExpandable && useContentBeforeButton && expandableContent, /*#__PURE__*/React.createElement("div", {
    className: "asc-expandable-content-top"
  }, iconType && /*#__PURE__*/React.createElement("div", {
    className: "asc-expandable-content-icon asc-pr-1"
  }, getIconElement()), /*#__PURE__*/React.createElement("div", {
    className: "asc-expandable-content-title"
  }, title, isExpandable && /*#__PURE__*/React.createElement(Button, {
    text: lockOpen || isOpen ? hideButtonWithIcon : showButtonWithIcon,
    className: "asc-btn--link asc-expandable-content-show",
    clickHandler: showClickHandler,
    customAttrs: {
      'aria-expanded': lockOpen || isOpen,
      'aria-controls': textId
    },
    disabled: lockOpen
  }))), isExpandable && !useContentBeforeButton && expandableContent);
};
export default ExpandableContent;